import React from 'react'
import irelandApi from '../irelandApi';
import {actions} from 'react-redux-form'
import * as moment from 'moment'
import {toast} from 'react-toastify';
import store, {history} from '../store'
import ToastMessage from '../components/common/toast-message'
import FileDownload from 'react-file-download'

export const getIncentive = (id) => (dispatch) => {
    dispatch({type: "GET_INCENTIVE_PENDING", payload: []});
    const url = `/api/admin/incentives/${id ? id : 'new'}`;
    return irelandApi
        .get(url)
        .then((response) => {
          const parseDate = (date) => {
            if (date) {
              return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
            } else {
              return '';
            }
          };
          const createProductList = (products) => {
            return products.map((curr) => {
              return {
                label: `${curr.sku_name} ${curr.sku_code}`,
                value: curr.id
              }
            });
          };
          const createGroupList = (groups) => {
            return attributes['all-groups'] ?
              [{label: 'All', value: 'all'}] :
              groups.map((curr) => {
                return {
                  label: `${curr.name}`,
                  value: curr.id
                }
              });
          };
          const data = response.data.data;
          const attributes = data.attributes;

            if(id){
              dispatch(actions.load('deep.incentives', {
                "name": attributes['name'],
                "start_date": attributes['start-date'],
                "end_date": attributes['end-date'],
                "kind": attributes['kind'].replace(/-/g, '_'),
                "reward_type": attributes['reward-type'].replace(/-/g, '_'),
                "target": attributes['target'],
                "default_target": attributes['default-target'],
                "maximum_points": attributes['maximum-points'],
                "percentage_calculate_from": attributes['percentage-calculate-from'],
                "percentage_calculate_to": attributes['percentage-calculate-to'],
                "points_to_target": attributes['points-to-target'],
                "points_to_target_2": attributes['points-to-target-2'],
                "points_after_target": attributes['points-after-target'],
                "display_from": attributes['display-from'],
                "display_to": attributes['display-to'],
                "start_date_before_current_date": attributes['start-date-before-current-date'],
                "product_ids": createProductList(attributes['products']),
                "group_ids": createGroupList(attributes['groups']),
                "prize_name": attributes['prize-name'],
                "prize_description": attributes['prize-description'],
                "prize_image_link": attributes['prize-image-link'],
                "prize_image_uid": attributes['prize-image-uid'],
                }));
              store.dispatch(actions.resetValidity('deep.incentives'));
            } else {
              dispatch(actions.load('deep.incentives', {
                "name": '',
                "start_date": '',
                "end_date": '',
                "kind": attributes['kind'].replace(/-/g, '_'),
                "reward_type": attributes['reward-type'].replace(/-/g, '_'),
                "target": '',
                "default_target": '',
                "maximum_points": '',
                "percentage_calculate_from": '',
                "percentage_calculate_to": '',
                "points_to_target": '',
                "points_after_target": '',
                "display_from": '',
                "display_to": '',
                "product_ids": '',
                "group_ids": '',
                "prize_name": '',
                "prize_description": '',
                "prize_image_link": '',
                "prize_image_uid": ''
              }));
              //dispatch(actions.change('deep.incentives.kind', response.data.data.attributes['kind'].replace(/-/g, '_')));

            }
          dispatch({
            type: "GET_INCENTIVE_FULFILLED",
            payLoad: response.data
          });
        })
        .catch((error) => {
          dispatch({
            type: 'GET_INCENTIVE_REJECTED',
            payLoad: error.response
          });
          return Promise.reject(error.response.data.errors);
        })
};

export const getIncentives = (page = 1) => (dispatch) => {
    dispatch({type: "GET_INCENTIVES_PENDING", payload: []});
  return irelandApi.get('/api/admin/incentives', {params: {page: page}})
                   .then((response) => {
                       dispatch({type: "GET_INCENTIVES_FULFILLED", payLoad: response.data});
                     })
                   .catch((error) => {
                       dispatch({type: 'GET_INCENTIVES_REJECTED', payLoad: error.data});
                       return Promise.reject(error.response.data);
                     })
  };

export const downloadIncentives = (id) => (dispatch) => {
  return irelandApi.get(`/api/admin/incentives/${id}/download`)
                   .then((response) => {
                    let filename = "Incentive.csv";
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(response.headers['content-disposition']);
                    if (matches && matches[1]) {
                      filename = matches[1].replace(/['"]/g, '');
                    }
                    FileDownload(response.data, filename);
                     })
                   .catch((error) => {
                    // toast.error(<ToastMessage iconStyle="error" message={`Incentive can not be downloaded: ${error.response.data.errors[0]}`}/>);
                  })
  };

const prepareIncentiveFormData = (payLoad) => {
  let formData = new FormData();
  Object.keys(payLoad).forEach(key => {
    if (key === 'product_ids' || key === 'group_ids') {
      payLoad[key].forEach(id => formData.append(`incentive[${key}][]`, id))
    } else {
      formData.append(`incentive[${key}]`, payLoad[key])
    }
  });
  return formData;
};

export const saveIncentive = (data) => (dispatch) => {
  const config = {
    headers: { 'content-type': 'multipart/form-data' }
  };

  let newIncentive = Object.assign({}, data);
  const formatDate = (date) => {
    // return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD")
    return moment(date).format("YYYY-MM-DD")
  };

  if (newIncentive.kind === 'percentage_increase') {
    newIncentive["percentage_calculate_from"] = formatDate(newIncentive["percentage_calculate_from"]);
    newIncentive["percentage_calculate_to"] = formatDate(newIncentive["percentage_calculate_to"]);
  }
  if (newIncentive.kind !== 'percentage_increase') {
    delete newIncentive["percentage_calculate_from"];
    delete newIncentive["percentage_calculate_to"];
  }

  if (!/^(base|fixed)_target$/.test(newIncentive.kind) && newIncentive["points_to_target_2"] !== undefined) {
    delete newIncentive["points_to_target_2"];
  }

  if (newIncentive["display_from"]) {
    newIncentive["display_from"] = formatDate(newIncentive["display_from"]);
  }
  if (newIncentive["display_to"]) {
    newIncentive["display_to"] = formatDate(newIncentive["display_to"]);
  }
  if (newIncentive["start_date"]) {
    newIncentive["start_date"] = formatDate(newIncentive["start_date"]);
  }
  if (newIncentive["end_date"]) {
    newIncentive["end_date"] = formatDate(newIncentive["end_date"]);
  }

  newIncentive["product_ids"] = newIncentive["product_ids"].map(curr => {
    return curr.value;
  });

  newIncentive["group_ids"] = newIncentive["group_ids"].map(curr => {
    return curr.value;
  });

  if (newIncentive["group_ids"].indexOf("all") > -1) {
    newIncentive["all_groups"] = true;
    delete newIncentive["group_ids"];
  }

  const formData = prepareIncentiveFormData(newIncentive);

  dispatch({type: "ADD_INCENTIVES_PENDING"});
  return irelandApi.post('/api/admin/incentives', formData, config)
                   .then((response) => {
                     dispatch({
                       type: "ADD_INCENTIVES_FULFILLED",
                       payLoad: response.data
                     });
                     toast.success(<ToastMessage iconStyle="success" message="Sales Incentive created successfully"/>);
                     history.push('/admin/sales_incentives');
                     dispatch(actions.reset('deep.incentives'));
                   })
                   .catch((error) => {
                     dispatch({
                       type: 'ADD_INCENTIVES_REJECTED',
                       payload: error.response.data
                     });
                     toast.error(<ToastMessage iconStyle="error" message="An error occurred during create Sales Incentive"/>);
                     if (error.response.data.errors) {
                       const errors = error.response.data.errors;
                       if (errors.base_target) {
                         dispatch(actions.setErrors('deep.incentives.file', errors.base_target));
                       }
                       ['maximum_points', 'points_after_target', 'points_to_target',
                        'points_to_target_2', 'target'].forEach((field) => {
                        if (errors[field]) {
                          dispatch(actions.setErrors(`deep.incentives.${field}`, errors[field]));
                        }
                      });
                     }
                   })
};

export const updateIncentive = (id, data) => (dispatch) => {
  let newIncentive = Object.assign({}, data);

  const formatDate = (date) => {
    return moment(date).format("YYYY-MM-DD")
  };

  if (newIncentive.kind === 'percentage_increase') {
    newIncentive["percentage_calculate_from"] = formatDate(newIncentive["percentage_calculate_from"]);
    newIncentive["percentage_calculate_to"] = formatDate(newIncentive["percentage_calculate_to"]);
  } else {
    delete newIncentive["percentage_calculate_from"];
    delete newIncentive["percentage_calculate_to"];
  }

  if (newIncentive["display_from"]) {
    newIncentive["display_from"] = formatDate(newIncentive["display_from"]);
  }
  if (newIncentive["display_to"]) {
    newIncentive["display_to"] = formatDate(newIncentive["display_to"]);
  }
  if (newIncentive["start_date"]) {
    newIncentive["start_date"] = formatDate(newIncentive["start_date"]);
  }
  if (newIncentive["end_date"]) {
    newIncentive["end_date"] = formatDate(newIncentive["end_date"]);
  }

  newIncentive["product_ids"] = newIncentive["product_ids"].map(curr => {
    return curr.value;
  });

  newIncentive["group_ids"] = newIncentive["group_ids"].map(curr => {
    return curr.value;
  });

  if (newIncentive["group_ids"].indexOf("all") > -1) {
    newIncentive["all_groups"] = true;
    delete newIncentive["group_ids"];
  }
  const formData = prepareIncentiveFormData(newIncentive);

  dispatch({type: "UPDATE_INCENTIVES_PENDING"});
  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };
  return irelandApi.patch(`/api/admin/incentives/${id}`, formData, config)
                   .then((response) => {
                     dispatch({
                       type: "UPDATE_INCENTIVES_FULFILLED",
                       payLoad: response.data
                     });
                     toast.success(<ToastMessage iconStyle="success" message="Sales Incentive updated successfully"/>);
                     history.push('/admin/sales_incentives');
                   })
                   .catch((error) => {
                     dispatch({
                       type: 'UPDATE_INCENTIVES_REJECTED',
                       payLoad: error.data
                     });
                     toast.error(<ToastMessage iconStyle="error" message="An error occurred during update Sales Incentive"/>);
                     return Promise.reject(error.response.data);
                   })
};



// WEBPACK FOOTER //
// ./src/actions/incentives.js